import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const SessionFilters = ({ filters, onFilterChange, totalSessions }) => {
  const deviceTypeOptions = [
    { value: 'all', label: 'All Devices' },
    { value: 'desktop', label: 'Desktop' },
    { value: 'mobile', label: 'Mobile' },
    { value: 'tablet', label: 'Tablet' },
    { value: 'unknown', label: 'Unknown' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active Only' },
    { value: 'inactive', label: 'Inactive Only' }
  ];

  const handleClearFilters = () => {
    onFilterChange({
      deviceType: 'all',
      status: 'active',
      searchTerm: ''
    });
  };

  return (
    <div className="card mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground flex items-center gap-2">
          <Icon name="Filter" size={20} />
          Filter Sessions
        </h3>
        <div className="flex items-center gap-3">
          <span className="text-sm text-muted-foreground">
            {totalSessions} {totalSessions === 1 ? 'session' : 'sessions'} found
          </span>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={handleClearFilters}
          >
            Clear
          </Button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Select
          options={deviceTypeOptions}
          value={filters?.deviceType}
          onChange={(value) => onFilterChange({ deviceType: value })}
          placeholder="Filter by device"
        />

        <Select
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange({ status: value })}
          placeholder="Filter by status"
        />

        <Input
          type="text"
          placeholder="Search by IP, location, or device..."
          value={filters?.searchTerm}
          onChange={(e) => onFilterChange({ searchTerm: e?.target?.value })}
        />
      </div>
    </div>
  );
};

export default SessionFilters;